export const SKIP_AUTH_HEADER_KEY = 'Skip-Auth';

export const SKIP_AUTH_HEADER = {
  [SKIP_AUTH_HEADER_KEY]: 'true',
};
